// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Box, Typography } from '../../../lib/base';

interface Props {
  readonly title: string | React.ReactElement;
  readonly subtitle: string;
}

export default function StackedTitle({ title, subtitle }: Props) {
  return (
    <Box sx={{ maxHeight: '60px', pt: 1, pb: 1 }} display="flex" flexDirection="column" alignItems="flex-start">
      {typeof title === 'string' ? <Typography variant="body1">{title}</Typography> : title}
      <Typography variant="body2">{subtitle}</Typography>
    </Box>
  );
}
